import {reactive} from "vue";

export const toastStore = reactive({
    isOpened: false,
    setIsOpened(value){
        this.isOpened = value;
    },
    message: '',
    setMessage(value){
        this.message = value;
    },
})

